import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import UnreadIndicatorView from '../component/UnreadIndicatorView'
import { getUnreadConversations } from '../../../shared/chat'

const UnreadIndicator = ({ websockets }) => {
  const [unreadsAmount, setUnreadsAmount] = useState(0)
  useEffect(() => {
    const { messages, conversations } = websockets

    const unreadedConversations = getUnreadConversations({
      conversations: Object.values(conversations),
      messages,
      isEndUser: false,
    })

    setUnreadsAmount(unreadedConversations.length)
  }, [websockets.conversations])

  if (unreadsAmount === 0) return null
  return <UnreadIndicatorView>{unreadsAmount}</UnreadIndicatorView>
}
const mapStateToProps = ({ websockets }) => ({
  websockets,
})
export default connect(mapStateToProps)(UnreadIndicator)



// WEBPACK FOOTER //
// ./src/Components/ChatUnreadIndicator/container/UnreadIndicator.js